'use client';

import usePopupObserver from '@/hooks/usePopupObserver';
const PopupObserver = () => {
  usePopupObserver();
  return null;
};
export default PopupObserver;